import ToolsProvider from './ToolsContext';
import Tools from './Tools';

let Index = () => {
    return (
        <ToolsProvider>
            <Tools />
        </ToolsProvider>
    )
}

export default Index;